import React from 'react';
import styles from './FeedBadge.module.css';

type BadgeType = 'offer' | 'conflict' | 'resolved' | 'entity' | 'project' | 'allied' | 'recommendation';

type FeedBadgeProps = {
  readonly type: BadgeType;
};

const BADGE_LABELS: Record<BadgeType, string> = {
  offer: 'Open Offer',
  conflict: 'Active Conflict',
  resolved: 'Resolved',
  entity: 'New Entity',
  project: 'Project',
  allied: 'Allied',
  recommendation: 'Intelligence',
};

const BADGE_ICONS: Record<BadgeType, string> = {
  offer: '◇',
  conflict: '✠',
  resolved: '✓',
  entity: '◆',
  project: '▣',
  allied: '⚐',
  recommendation: '◈',
};

const FeedBadge = ({ type }: FeedBadgeProps): React.ReactElement => (
  <span className={`${styles.badge} ${styles[type]}`}>
    {BADGE_ICONS[type]} {BADGE_LABELS[type]}
  </span>
);

export { FeedBadge };
export type { BadgeType };
